var exports = {
  "link": "x2b2fbebb--145fce--link",
  "link--white": "x2b2fbebb--145fce--link--white",
  "link--block": "x2b2fbebb--145fce--link--block",
  "link--fullwidth": "x2b2fbebb--145fce--link--fullwidth",
};

module.exports = exports;
